<div class="mt-4">
  <mat-card class="card-style">
    <div class="flex justify-start mb-2">
      <mat-form-field class="input-tg w-4/12" appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select [(ngModel)]="statusId" (selectionChange)="onStatusChange()">
          @for (opcao of opcoesStatus; track opcao.id) {
            <mat-option [value]="opcao.id">{{ opcao.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    @if (!loading) {
      <div>
        <table-list-supplier-portal-quote
          [dataSource]="itemsList"
          [columns]="columns"
          (openItem)="openItem($event)"
        />
        @if (itemsList.length > 0) {
          <mat-paginator
            [length]="numberRows"
            [pageSize]="rows"
            [pageIndex]="page - 1"
            [pageSizeOptions]="[5, 10, 20, 30]"
            (page)="onPageEvent($event)"
          >
          </mat-paginator>
        }
      </div>
    } @else {
      <div>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
  </mat-card>
</div>
